export class CreateConnectorInput {
    'name';
    'connectorType';
    'awsAccountProperties';
    'gcpProjectProperties';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "connectorType",
            "baseName": "connectorType",
            "type": "ConnectorType",
            "format": ""
        },
        {
            "name": "awsAccountProperties",
            "baseName": "awsAccountProperties",
            "type": "CreateConnectorInputAwsAccountProperties",
            "format": ""
        },
        {
            "name": "gcpProjectProperties",
            "baseName": "gcpProjectProperties",
            "type": "CreateConnectorInputGcpProjectProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateConnectorInput.attributeTypeMap;
    }
    constructor() {
    }
}
